import { useEffect, useState, useContext } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { Page, Msg, LoadMore, Toast, Panel } from 'react-weui';
import PropTypes from 'prop-types';
import { formatDate } from 'lib/formatter.ts';
import TopNav from 'components/topNav.jsx';
import * as MobileActions from 'actions/index.ts';
import useList from 'hooks/useList';
import CommonFns from 'functions/common.ts';
import Http from 'services/http2';
import ModalService from 'services/modal';
import { ActionContext } from 'actions/context';

// 重要度
const ImportList = {
  1: '低',
  2: '中',
  3: '高'
};

function QuestionnaireList(props) {
  const Config = {
    sale: {
      title: '客户问卷',
      apiPath: '/b2bquestionnaire/cusNaire/list',
      // enumMainKey: '',
      detailLink: '/mp/sale/customer/questionnaire/detail',
      searchBarPlaceholder: '问卷名称/编码',
      tabs: ['所有问卷'],
      tabConfig: [
        undefined //全部
      ],
      orderProperty: 'createTime',
      arrEnumField: [
        {
          mainKey: 'B02_Question_Val_Status',
          subKey: 'validFlag',
          value: 'valStatusName'
        },
        {
          mainKey: 'B02_Question_Ack_Status',
          subKey: 'ackStatus',
          value: 'ackStatusName'
        }
      ]
    }
  };
  const config = Config[props.type];
  const {
    companyCode,
    searchKey,
    inited,
    error,
    dataError,
    updateTs,
    currentTab,
    total,
    showLoading,
    list,
    setListField,
    count,
    setCount,
    handleTab,
    handleChange,
    handleClear,
    self
  } = useList(props, config);
  const { state, dispatch } = useContext(ActionContext);
  const [isNew, setIsNew] = useState(false);

  //初始化默认企业
  useEffect(() => {
    self.init();
  }, [self]);

  //companyCode改变时执行
  useEffect(() => {
    self.getCount();
  }, [companyCode, self]);

  //list, total参数设置
  useEffect(() => {
    setListField('questionnaireList');
  }, [setListField]);

  //根据依赖多次执行
  useEffect(() => {
    self.search();
  }, [searchKey, companyCode, currentTab, self]);

  // 新建请购
  function create(data) {
    let postbody = {
      companyCode,
      ...data,
      apiPath: '/b2bRequisitionOrder/createReqOrder'
    };
    Http.post('/api/cloudCenter', postbody).then(response => {
      if (response.success) {
        let url = `${config.detailLink}/${companyCode}/${response.data}`;
        props.history.push(url);
      } else {
        ModalService.showError(response.errorMsg, dispatch);
      }
    });
  }

  //显示错误
  if (error !== null) {
    return <Msg {...error} />;
  }

  return (
    <Page
      transition={false}
      ptr={false}
      onLoadMore={(resolveLoading, finish) => {
        self.pageResolveLoading = resolveLoading;
        if (list.length >= total) {
          finish();
        } else {
          self.search();
        }
      }}
      className="v2"
    >
      <TopNav
        inited={inited}
        onSubmit={handleChange}
        onCancel={handleClear}
        onClear={handleClear}
        defaultValue={searchKey}
        placeholder={config.searchBarPlaceholder}
      />
      <Panel>
        {dataError !== null ? (
          <Msg {...dataError} />
        ) : (
          <span>
            <div className="m-tab-container">
              <ul className="m-flex-box">
                {config.tabs.map((item, index) => (
                  <li
                    key={index}
                    onClick={() => {
                      handleTab(index);
                    }}
                    className={
                      currentTab === index ? 'm-flex-item curr' : 'm-flex-item'
                    }
                  >
                    <span className="name">{item}</span>
                    {count[index] && (
                      <sup className="u-num">{count[index]}</sup>
                    )}
                  </li>
                ))}
              </ul>
            </div>
            <div className="list-total">{total}</div>
            <div className="m-details-item">
              <div className="details-item-content">
                {updateTs > 0 &&
                  list.map((item, index) => (
                    <Link
                      to={`${config.detailLink}/${companyCode}/${item.companyCode}/${item.id}/${item.questionnaireCode}`}
                      key={index + item.id}
                      className="content-line line-list-item"
                    >
                      <div className="line-list-item-title">
                        <span>{item.questionnaireCode}</span>
                        <div className="more">
                          <span
                            className={
                              'u-sign ' +
                              CommonFns.getStatusClass(
                                'B02_Question_Ack_Status',
                                item.ackStatus
                              )
                            }
                          >
                            {item.ackStatusName}
                          </span>
                        </div>
                      </div>
                      <ul className="field-list">
                        <li>
                          <label>问卷标题</label>
                          <div>{item.questionnaireTitle}</div>
                        </li>
                        <li>
                          <label>发起方</label>
                          <div>{item.companyName}</div>
                        </li>
                        <li>
                          <label>操作人</label>
                          <div>{item.updateName}</div>
                        </li>
                        <li>
                          <label>更新时间</label>
                          <div>{formatDate(item.updateTime)}</div>
                        </li>
                        <li>
                          <label>开始时间</label>
                          <div>{formatDate(item.startTime)}</div>
                        </li>
                        <li>
                          <label>结束时间</label>
                          <div>{formatDate(item.endTime)}</div>
                        </li>
                        <li>
                          <label>重要度</label>
                          <div>{ImportList[item.importanceDegree]}</div>
                        </li>
                      </ul>
                    </Link>
                  ))}
                {!showLoading && list.length === 0 && (
                  <LoadMore showLine> 暂无数据</LoadMore>
                )}
              </div>
            </div>
          </span>
        )}
      </Panel>
      <Toast icon="loading" show={showLoading}>
        数据加载中...
      </Toast>
    </Page>
  );
}

QuestionnaireList.propTypes = {
  actions: PropTypes.object.isRequired
};

const mapDispatchToProps = dispatch => {
  return {
    actions: bindActionCreators(MobileActions, dispatch)
  };
};

export default connect(mapDispatchToProps)(QuestionnaireList);
